<template>
  <div class="part">
    <v-container fluid class="d-flex-column ma-2 justify-space-between">


<part-detail-card
  title="Ανταλλακτικό"
  :pid="$route.params.id"
  api="/inventory/parts/info/"
  >
  <template v-slot:tabsleft>
    <!--  <v-btn
        color="primary"
        dense
        @click="invodialog=true"
      >
      <v-icon>mdi-file-document</v-icon>
      </v-btn>
     <invoice-dialog :cid="$route.params.id" :dialog.sync="invodialog" />
    -->
    
  </template>

  <template v-slot:tabsright>
    <v-tab replace :to="{ name: 'part-info' }">Πληροφοριες</v-tab>
    <v-tab replace :to="{ name: 'part-references' }">Αντιστοιχιες</v-tab>
    <v-tab replace :to="{ name: 'part-orders' }">Παρτιδες</v-tab>
    <v-tab replace :to="{ name: 'part-checkouts' }">Χρεωσεις</v-tab>
   <!-- <v-tab replace :to="{ name: 'part-invoices' }">Τιμολογια</v-tab>
   <v-tab replace :to="{ name: 'part-repairs' }">Επισκευές</v-tab> -->
  </template>
</part-detail-card>
 <router-view></router-view>

    </v-container>
  </div>
</template>

<script>
import PartDetailCard from '../../components/PartDetailCard.vue';

// import InvoiceDialog from '../../components/InvoiceDialog.vue';

export default {
  components: {
    PartDetailCard,
  //  InvoiceDialog,
  },
  data() {
    return {
      expanded: [],
      invodialog: false,
      paymdialog: false,
      printDialog: false,
      showLabelDialog: false,
      loading: true,
      search: '',
      customer_id: this.$route.params.id,
    }
  },
  async created() {
    },
  methods: {

  }
}
</script>
